/* Announcement bar: rotation with pause, and per-visitor dismissal. */

/* Defined inside a guard so a second <script> tag for this file is a no-op rather than
   a redeclaration error. */
if (!customElements.get('wly-announcement')) {
  class WlyAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-wly-ann-item]'));
      this.index = 0;
      this.timer = null;

      if (this.hasAttribute('data-dismissible') && this.isDismissed()) {
        this.remove();
        return;
      }

      this.querySelector('[data-wly-ann-close]')?.addEventListener('click', () => this.dismiss());

      if (this.hasAttribute('data-rotate') && this.items.length > 1) {
        this.toggleBtn = this.querySelector('[data-wly-ann-toggle]');
        this.toggleBtn?.addEventListener('click', () => this.toggle());

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) {
          this.setPaused(true);
        } else {
          this.start();
        }

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          if (!this.paused) this.start();
        });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => {
          if (!this.paused) this.start();
        });
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    get interval() {
      return parseInt(this.getAttribute('data-interval'), 10) || 6000;
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const from = this.items[this.index];
      this.index = (this.index + 1) % this.items.length;
      const to = this.items[this.index];
      from.hidden = true;
      from.classList.remove('is-active');
      to.hidden = false;
      // Next frame, so the transition has a start state to animate from.
      requestAnimationFrame(() => to.classList.add('is-active'));
    }

    toggle() {
      this.setPaused(!this.paused);
    }

    setPaused(paused) {
      this.paused = paused;
      if (paused) this.stop();
      else this.start();
      if (!this.toggleBtn) return;
      this.toggleBtn.classList.toggle('is-paused', paused);
      const label = paused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause;
      this.toggleBtn.setAttribute('aria-label', label);
    }

    isDismissed() {
      try {
        return localStorage.getItem(this.getAttribute('data-storage-key')) === '1';
      } catch {
        return false;
      }
    }

    dismiss() {
      try {
        localStorage.setItem(this.getAttribute('data-storage-key'), '1');
      } catch {
        /* private mode or blocked storage: the bar simply comes back next visit */
      }
      this.remove();
    }
  }

  customElements.define('wly-announcement', WlyAnnouncement);
}
